__turbopack_context__.v({
  "active": "sidebar-main-navigation-module-sass-module__jTkMGG__active",
  "casinoNavItem": "sidebar-main-navigation-module-sass-module__jTkMGG__casinoNavItem",
  "liveNavItem": "sidebar-main-navigation-module-sass-module__jTkMGG__liveNavItem",
  "nav": "sidebar-main-navigation-module-sass-module__jTkMGG__nav",
  "navItem": "sidebar-main-navigation-module-sass-module__jTkMGG__navItem",
  "sportNavItem": "sidebar-main-navigation-module-sass-module__jTkMGG__sportNavItem",
});
